import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { OrderItemStatus } from 'src/interfaces/order-item';
import { MatSelectChange } from '@angular/material/select';
import { LoaderService } from 'src/core/services/loader.service';
import { BatchStatus } from 'src/interfaces/batch';
import { DirtinessService } from 'src/core/services/dirtiness.service';
import { BatchService } from 'src/core/services/batch.service';
import { Order } from 'src/interfaces/order';
import { OrderStatus } from 'src/interfaces/order-status';
import { OrderMedicineItem } from 'src/interfaces/order-medicine-item';
import { AlertService } from 'src/core/services/alert.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'core-order-medicine-item-list',
  templateUrl: './order-medicine-item-list.component.html',
  styleUrls: ['./order-medicine-item-list.component.scss']
})
export class OrderMedicineItemListComponent implements OnInit, OnChanges {

  displayedColumns: string[] = [
    'dosage',
    'pack_size',
    'price',
    'remove'
  ];

  dataSource = new MatTableDataSource<OrderMedicineItem>([]);
  
  @Input() 
  set orderItems(items: OrderMedicineItem[]) {
    if (items) {
      this.dataSource.data = items;
    }
  }
  
  get orderItems(): OrderMedicineItem[] {
    return this.dataSource.data;
  }
  
  @Input() order: Order;
  @Input() orderItemStatuses: OrderItemStatus[] = [];
  @Input() batchStatuses: BatchStatus[] = [];
  @Input() orderStatus: OrderStatus | null = null;
  newBatchStatusCode: string = "AWM";
  statusCodes: {
    awaitingFulfilment: string,
    awaitingManufacture: string,
    inStock: string,
    procured: string,
    packed: string,
  } = {
      awaitingFulfilment: "AWF",
      awaitingManufacture: "AWM",
      inStock: "ISK",
      procured: "PRC",
      packed: "PKD",
    };
  @Output() onDelete = new EventEmitter<OrderMedicineItem>();
  isLoading: boolean = false;
  selectedItem: OrderMedicineItem | null = null;


  constructor(
    private _loaderService: LoaderService,
    private _dirtinessService: DirtinessService,
    private _batchService: BatchService,
    private _alertService: AlertService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderItems) {
      this.dataSource.data = changes.orderItems.currentValue || [];
    }
    
    if (this.orderStatus) {
      if (this.orderStatus.code === 'SHP') {
        this.displayedColumns = this.displayedColumns.filter(column => column !== 'remove');
      } else {
        if(!this.displayedColumns.includes('remove'))
        this.displayedColumns.push('remove');
      }
    }
  }

  ngOnInit(): void {
    this
      ._loaderService
      .isLoading
      .subscribe(isLoading => {
        this.isLoading = isLoading;
      });

    if (this.orderStatus) {
      if (this.orderStatus.code === 'SHP') {
        this.displayedColumns = this.displayedColumns.filter(column => column !== 'remove');
      }
    }
  }

  deleteOrderItem(item: OrderMedicineItem) {
    this.onDelete.emit(item);
  }

  changeOrderItemStatus(event: MatSelectChange, orderItem: OrderMedicineItem) {
    this._dirtinessService.setDirty(true);
    orderItem.status = event.value;
  }

  getStatus(orderItem: OrderMedicineItem) {
    const orderItemStatus: OrderItemStatus | undefined = this
      .orderItemStatuses
      .find((orderItemStatus: OrderItemStatus) => {
        if (!orderItem.status) return false;
        return orderItemStatus.id === orderItem.status.id;
      })
    if (!orderItemStatus) return null;
    return orderItemStatus;
  }

  disableStatus(status: OrderItemStatus): boolean {
    return (
      status.code === 'PRC'
      ||
      status.code === 'PKD'
    )
  }

  async printLabels(orderItems: OrderMedicineItem[]) {
    this._alertService.errorAlert("Printing labels for order medicine items is not yet implemented.");
  }

  async printAllLabels() {
    this._alertService.errorAlert("Printing labels for order medicine items is not yet implemented.");
  }
} 